export default {
  text: "#000",
  backgroundPrimary: "#000",
  backgroundSecondary: "#47c1bf",
  actionPrimary: "#f7b44e",
  backgroundDarkBlue: "#f7b44e",
  actionGreen: "#00B5B8",
  textGreen: "#1DE9B6",
  textLightBlue: "#BCDFFF",
  textDarkBlue: "#000000"
}



// WEBPACK FOOTER //
// ./src/lib/theme/colors.js